module.exports = __webpack_public_path__ + "static/media/4.76cf5803.jpg";